var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('vs-select',{attrs:{"dir":"rtl","data":_vm.voucherTypes,"header-key":_vm.headerKey,"mode":_vm._mode,"header":{multiple: false, label: 'name'},"selected-val":_vm.selectedType},on:{"dataChanged":_vm.onDataChanged}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }